import React, { useEffect } from 'react';
import useStorage from '../hooks/useStorage';
//import { motion } from "framer-motion";

const ProgressBar = props => {
  const { url, progress } = useStorage(props.file);
  console.log(url);

  useEffect(() => {
    if (url) {
      props.setFile(null);
      props.setPictresURL([...props.picturesURL, url]);
    }
  }, [url]);

  return (
    <div className="progress-bar" style={{}}>
      {progress} % {url}
    </div>
  );
};

export default ProgressBar;
